import { getOnDisplay } from '@/common/converter/utils/get-event-property'
import { restEventCommonParams } from '@/common/converter/const'

/**
 * convert event 'on-display'
 * @param elementList
 * @returns {{type: string, url: string, method: string, bodylist: [], add_common_params: string, add_timestamp: string, add_credential: string}|undefined}
 */
export const convertEventOnDisplay = (elementList = []) => {
  const { type, url, method, bodyList, isRender } = getOnDisplay(elementList)

  if (!isRender) return undefined

  return {
    type,
    url,
    method,
    bodylist: bodyList,
    ...restEventCommonParams,
  }
}
